import { render } from "./OurReservesnResources.vue?vue&type=template&id=a9ded794&scoped=true"
import script from "./OurReservesnResources.vue?vue&type=script&lang=js"
export * from "./OurReservesnResources.vue?vue&type=script&lang=js"

import "./OurReservesnResources.vue?vue&type=style&index=0&id=a9ded794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ded794"]])

export default __exports__